import React, { Component } from 'react';
import Dotdotdot from 'react-dotdotdot'
import moment from 'moment/min/moment-with-locales'
import { Link } from 'react-router-dom'

import ButtonCustom from '../../components/default/ButtonCustom'
import MiniPaginationCustom from '../../components/default/MiniPaginationCustom'

import { connect } from 'react-redux'
import { fetchCategoriesBoard } from '../../actions/categoryBoard'
import { fetchBoards } from '../../actions/boards'

class Webboard extends Component {
    state = {
        topicCategory: 0,
        start: 0,
        end: 10,
        page: 1
    }

    componentDidMount = () => {
        this.props.fetchCategoriesBoard()
        this.props.fetchBoards()
    }

    renderTimeFormNow = (time) => {
        moment.locale('th');
        return moment(time).fromNow();
    }
    
    handleDisplayCategory = () => {
        const showCategory =  this.props.categories.find(category => {
            return category.id === this.state.topicCategory
        })

        if(this.state.topicCategory === 0) {
            return <div className="webboard-status-card">ทุกหัวข้อสนทนา</div>
        } else {
            return (
                <div className="webboard-status-card is-row"><div className="webboard-dot" style={{backgroundColor: showCategory.color}}></div>{showCategory.name}</div>
            )
        }
    }

    handleCategory = (index) => {
        this.setState({
            topicCategory: index
        })
        this.props.fetchBoards({search: index})
    }

    onPageChange = (page, pageSize) => {
        let start = (page - 1) * pageSize
        let end = start + pageSize
        this.setState({ start, end, page })
    }

    render() {
            const topicCategory = this.state.topicCategory
            return (
                <div className="page-list-wrap">
                    <div className="page-list">
                        <div className="page-list-title gapb-24">กระดานสนทนา</div>   
                        <div className="is-row flex-align-start is-sm-row sm-gapr-0 gapb-32">
                            <div className="webboard-sidebar gapr-32 sm-gapr-0 is-sm-100">
                                <div className="gapb-16">
                                    <ButtonCustom
                                        borderRadius="4"
                                        color="green"
                                        label="ตั้งกระทู้ใหม่"
                                        fontSize={16}
                                        fontWeight="large"
                                        size="extra"
                                        href="/topic/add"
                                        className="center"
                                    />
                                </div>
                                <div className={`is-row webboard-sidebar-item gapb-8 ${topicCategory === 0 ? 'active' : ''}`} onClick={() => this.handleCategory(0)}>
                                    <div className="gapr-12">
                                        <img src="../resources/images/ic-topic.svg" alt="topic"/>
                                    </div>
                                    <div className="all-topic-text">ทุกหัวข้อสนทนา</div>
                                </div>
                                <ul className="webboard-sidebar-item-wrap">
                                    {
                                        this.props.categories.map((category, index) => (
                                            <li key={index}>
                                                <div className={`webboard-sidebar-item is-row ${topicCategory === category.id   ? 'active' : ''}`} onClick={() => this.handleCategory(category.id)}>
                                                    <div className="webboard-box gapr-12" style={{backgroundColor: category.color}}></div>{category.name}
                                                </div>
                                            </li>
                                        ))
                                    }
                                </ul>
                            </div>
                            <div className="is-100">
                                <div className="webboard-status-card-wrap gapb-14">
                                    {this.handleDisplayCategory()}
                                </div>
                                <div className="topic-list-wrap">
                                    {
                                        this.props.boards.slice(this.state.start, this.state.end).map((topic, index) => (
                                            <Link to={`/topic/${topic.id}`} className="topic-item-wrap is-row flex-align-start flex-between" key={index}>
                                                <div className="is-row">
                                                    <div className="profile-image gapr-32 is-desktop">
                                                        <img src={topic.image} alt="profile"/>
                                                    </div>
                                                    <div className="topic-detail-wrap gapr-32">
                                                        <div className="is-row">
                                                            <div className="topic-title gapr-8">{topic.title}</div>
                                                            <div className="topic-category-tags" style={{backgroundColor: topic.category_color}}>{topic.category_name}</div>
                                                        </div>
                                                        <div className="topic-info">โดย: {topic.create_by} {this.renderTimeFormNow(topic.created)}</div>
                                                        <Dotdotdot clamp={2} className="topic-detail" title={topic.detail}>
                                                            <div  dangerouslySetInnerHTML={{ __html: topic.detail }}/>
                                                        </Dotdotdot>
                                                    </div>
                                                </div>
                                                <div className="is-row comment-number is-desktop">
                                                    <div className="gapr-12">
                                                        <img src="../resources/images/ic-comment.svg" alt="comment"/>
                                                    </div>
                                                    <div>{topic.count_comment}</div>
                                                </div>
                                            </Link>
                                        ))
                                    }
                                </div>
                            </div>
                        </div>  
                        <div className="is-row flex-center">
                            <MiniPaginationCustom 
                                color="green"
                                total={this.props.boards.length} 
                                pageSize={10}
                                current={this.state.page}
                                onChange={this.onPageChange}
                            />
                        </div>
                    </div>
                </div>
            );
        
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        user: state.user,
        categories: state.categories,
        boards: state.boards
    }
}

const mapDispatchToProps = {
    fetchCategoriesBoard,
    fetchBoards
}

export default connect(mapStateToProps, mapDispatchToProps)(Webboard)

